<template>
	<div>
		<custom-header></custom-header>
		<section class="content">
			<div class="columns">
				<div class="column">
					<h1>Dispense</h1>
				</div>
			</div>
			<my-ikedc></my-ikedc>
		</section>
	</div>
</template>

<script>
import axios from 'axios'
import url from '../utils/url'
import CustomHeader from '@/components/CustomHeader'
import MyIkedc from '@/pages/IKEDC'
export default {
	name: 'hello',
	components: {
		CustomHeader, MyIkedc
	},
	data() {
		return {
			phone: '',
			amount: '',
			messageClass: 'is-hidden',
			message: '',
			submitClass: 'button is-success',
			service: 'ikedc'
		}
	},
	mounted() {

	},
	methods: {
		onDispense: function() {
			let self = this
			self.submitClass = "button is-success is-loading"
			if (!self.amount || !self.phone) {
				self.submitClass = "button is-success"
				self.message = 'Missing parameter'
				self.messageClass = "notification is-danger"
				return;
			}
			axios({
				url: `/support/airtime`,
				baseURL: url,
				method: 'post',
				headers: {
					authorization: window.localStorage.getItem('biyadmin')
				},
				data: {
					phone: self.phone,
					amount: self.amount
				}
			})
				.then(function(result) {
					self.submitClass = "button is-success"
					self.phone = ''
					self.amount = ''
					self.message = "Successful"
					self.messageClass = "notification is-success"
				})
				.catch(function(error) {
					self.message = error.response.data.message ? error.response.data.message : 'There was an error'
					self.messageClass = "notification is-danger"
					self.submitClass = "button is-success"
				})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	min-height: 600px;
}
</style>



// WEBPACK FOOTER //
// Dispense.vue?bc65ff92